import { ITypedModel, key } from 'core-ts-types';
import { Model } from 'utility-ts-orm';
export type feedbackSuggestedPlanStatus = 'COMMITTED' | 'EDITING' | 'RESOLVED' | 'RESOLVING' | '' | 'BLOCKED';

interface IPlanAdvisor {
  id: number | null;
  first_name: string;
  last_name: string;
}
export interface IFeedbackSuggestedPlanModel {
  id: number | null;
  status: feedbackSuggestedPlanStatus;
  created_ts: string;
  updated_ts: string;
  edited_by: IPlanAdvisor;
  committed_by: IPlanAdvisor | null;
  committed_ts: string | null;
  edited_ts: string | null;
  is_active: true;
  from_editing: boolean;
  previous_status: string | null;
}

export type FeedbackSuggestedPlanModel = ITypedModel<IFeedbackSuggestedPlanModel>;

angular
  .module('capability-ng-academic-planner')
  .factory('ngFeedbackSuggestedPlanModel', (): FeedbackSuggestedPlanModel => {
    return new Model<IFeedbackSuggestedPlanModel>({
      id: null,
      status: '',
      created_ts: '',
      updated_ts: '',
      edited_ts: '',
      previous_status: null,
      committed_ts: '',
      from_editing: false,
      edited_by: {
        id: null,
        first_name: '',
        last_name: ''
      },
      committed_by: {
        id: null,
        first_name: '',
        last_name: ''
      },
      is_active: true
    });
  });



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/suggestions/components/plan_feedback/models/feedback_suggested_plan_model.ts